import React from "react";
import { siteContent } from "../content";
const partners = siteContent.projectPartners;

const Partners = () => {
  return (
    <div className="mt-10">
      <div className="container">
        <h1 className="text-center font-bold text-4xl text-slate-800 py-20">
          {partners.title}
        </h1>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-5">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((l, i) => (
            <div
              key={i}
              className="border-t-4 border-greenish shadow-lg shadow-slate-100 p-3"
            >
              <img
                alt=""
                className="block max-h-[100px] mx-auto"
                src={`/images/logos/project-partner-${i < 9 ? "0" + l : l}.jpg`}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Partners;
